import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { ZEFFY_DONATE_URL, ZEFFY_5K_URL } from "@/lib/api";

const links = [
    { to: "/home", label: "Home" },
    { to: "/register", label: "Register" },
    { to: "/sponsor", label: "Sponsor" },
    { to: "/volunteer", label: "Volunteer" },
    { to: "/send-note", label: "Send a Note" },
];

const externalLinks = [
    { href: ZEFFY_5K_URL, label: "5K Run", testid: "5k-run" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    return (
        <header className="sticky top-0 z-40 bg-[#F2E8D5]/90 backdrop-blur border-b border-stone-300/60">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
                <Link to="/home" data-testid="nav-logo" className="flex items-center gap-2">
                    <span className="inline-block w-8 h-8 rounded-full border-2 border-brand-purple flex items-center justify-center">
                        <span className="w-4 h-4 rounded-full bg-brand-lime" />
                    </span>
                    <span className="font-serif text-lg tracking-tight">Poppa &amp; Gigi&apos;s <span className="font-accent text-brand-purple text-2xl">Promise</span></span>
                </Link>
                <nav className="hidden md:flex items-center gap-7">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-link-${l.to.replace("/", "")}`}
                            className={({ isActive }) =>
                                `text-sm tracking-wide uppercase font-medium transition-colors ${
                                    isActive ? "text-brand-purple" : "text-stone-700 hover:text-brand-purple"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    {externalLinks.map((l) => (
                        <a
                            key={l.testid}
                            href={l.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={`nav-link-${l.testid}`}
                            className="text-sm tracking-wide uppercase font-medium text-stone-700 hover:text-brand-purple transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href={ZEFFY_DONATE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="nav-cta-donate"
                        className="ml-2 px-5 py-2 rounded-full bg-brand-purple text-white text-sm font-semibold hover:bg-brand-purple-light transition"
                    >
                        Donate
                    </a>
                </nav>
                <button
                    data-testid="nav-mobile-toggle"
                    className="md:hidden p-2 text-stone-700"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>
            {open && (
                <div className="md:hidden bg-[#F2E8D5] border-t border-stone-300/60 px-4 py-3 flex flex-col gap-3">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            onClick={() => setOpen(false)}
                            data-testid={`mobile-nav-link-${l.to.replace("/", "")}`}
                            className="py-2 text-sm uppercase tracking-wide font-medium text-stone-800"
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    {externalLinks.map((l) => (
                        <a
                            key={l.testid}
                            href={l.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => setOpen(false)}
                            data-testid={`mobile-nav-link-${l.testid}`}
                            className="py-2 text-sm uppercase tracking-wide font-medium text-stone-800"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href={ZEFFY_DONATE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setOpen(false)}
                        data-testid="mobile-nav-cta-donate"
                        className="py-2 text-sm uppercase tracking-wide font-semibold text-brand-purple"
                    >
                        Donate
                    </a>
                </div>
            )}
        </header>
    );
}
